module.exports = __webpack_public_path__ + "img/EducationalScheduleTimes.aa00a6a4.svg";